import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EditIntegrationComponent } from './components/edit-integration/edit-integration.component';
import { EditIntegrationConfigComponent } from './components/edit-integration-config/edit-integration-config.component';
import { IntegrationDetailsViewComponent } from './components/integration-details-view/integration-details-view.component';
import { IntegrationLockComponent } from './components/integration-lock/integration-lock.component';
@NgModule({
  imports: [
    CommonModule,
    EditIntegrationComponent,
    EditIntegrationConfigComponent,
    IntegrationDetailsViewComponent,
    IntegrationLockComponent,
  ],
  exports: [
    EditIntegrationComponent,
    EditIntegrationConfigComponent,
    IntegrationDetailsViewComponent,
    IntegrationLockComponent,
  ],
})
export class LTConfigurationInfoModule { }